import WexPage from './WexPage';

import Testimonies from '../components/testimonies';

/**
 * Site specific stuffs.
 */
export default class extends WexPage {
    init() {
        super.init();

        // Header background image is now set via render-blocking CSS in <head>
        // (see mains/public/main.blade.php) — no JS needed, no flash.

        // Detect feedback blocks.
        document
            .querySelectorAll('.testimonies')
            .forEach((el) => this.initComponent(el, Testimonies));

        // Desktop dropdown selects
        this.app.vue.buildSingleComponent(
            document.getElementById('select-locale'),
            require('./../vue/SelectLocale.vue')
        );
        this.app.vue.buildSingleComponent(
            document.getElementById('select-timezone'),
            require('./../vue/SelectTimezone.vue')
        );
        this.app.vue.buildSingleComponent(
            document.getElementById('select-currency'),
            require('./../vue/SelectCurrency.vue')
        );

        // Mobile modal selects
        this.app.vue.buildSingleComponent(
            document.getElementById('select-locale-modal'),
            require('./../vue/SelectLocale.vue')
        );
        this.app.vue.buildSingleComponent(
            document.getElementById('select-timezone-modal'),
            require('./../vue/SelectTimezone.vue')
        );
        this.app.vue.buildSingleComponent(
            document.getElementById('select-currency-modal'),
            require('./../vue/SelectCurrency.vue')
        );

        // Initialize currency menu label
        this.initUserCurrency();

        // Burger menu.
        document
            .querySelector('#header-mobile-menu a')
            .addEventListener('click', (e) => {
                e.preventDefault();
                const opened = document
                    .getElementById('menu-links')
                    .classList.toggle('opened');
                if (opened) {
                    document
                        .getElementById('menu')
                        .scrollIntoView({behavior: 'smooth'});
                }
            });

    }

    initAllComponents(selector, Component) {
        // Init all accordions.
        document.querySelectorAll(selector).forEach((el) => {
            this.initComponent(el, Component);
        });
    }

    initUserCurrency() {
        document.getElementById('user-currency-menu-label').innerHTML =
            this.app.getSelectedCurrency().code;
    }
}
